import {Button, Col, FormControl, InputGroup, Modal, Row} from "react-bootstrap";
import ResourceComponent from "../../components/ResourceComponent";
import {
    defaultDateFormat,
    defaultDateTimeFormat,
    defaultTimeFormat,
    mapForSelect,
    select
} from "../../common/commonHandlers";
import moment from "moment";
import Datetime from "react-datetime";
import React from "react";
import Select from "react-select";
import './TermModal.css';
import InputGroupAddon from "react-bootstrap/lib/InputGroupAddon";
import Payments from "./Payments";
import ColorCheckbox from "../Scheduler/ColorCheckbox";
import {withMediaQuery} from '../../utilities/hooks/useMediaQuery';


class TermModal extends ResourceComponent {
    constructor(props) {
        super(props);
        this.state = {
            resource: {
                invoiced_at: moment(),
                paid_at: null,
            },
            isTermValidated: true,
            isPaymentValidated: true,
            isDateValidated: true,
            isEdited: false,
            isPaid: false,
            payment: {
                payment_date: null,
                amount: 0
            },
            partial: false,
            addingPayments: false,
            reload: true
        };


    }

    parseDecimal = (number) => {
        number = parseFloat(number)
        const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            style: "decimal"
        });
        return formatter.format(number)

    }

    resetValues = () => {
        this.setState({isTermValidated: true, isPaymentValidated: true, isDateValidated: true, payment_date: moment()})

    }

    resetAmountsToOriginal = () => {
        const {payments} = this.state.resource;
        const {payment} = this.state;

        const updatedPayments = payments?.map(payment => {
            if (payment.amount_before !== undefined) {
                return {
                    ...payment,
                    amount: payment.amount_before,
                    amount_before: undefined
                };
            }
            return payment;
        });

        let amount = this.props.invoice.total || 0;
        if (this.props.invoice.payments) {
            for (let p of this.props.invoice.payments.filter(p => p.status !== 'refunded')) {
                const valueToSubtract = p.amount_before !== undefined ? parseFloat(p.amount_before) : parseFloat(p.amount);
                amount -= valueToSubtract;
            }
        }
        payment.amount = parseFloat(amount.toFixed(2));
        this.setState({
            resource: {
                ...this.state.resource,
                payments: updatedPayments
            },
            payment
        });
    };

    componentDidUpdate(prevProps, prevState) {
        const {payment} = this.state;

        if (prevState.payment.amount !== payment.amount) {
            const isPaid = +payment.amount <= 0;
            this.setState({isPaid})
        }

        if (prevProps.loading !== this.props.loading) {
            this.setState({reload: true})
        }

        if (!prevProps.show && this.props.show && this.state.reload) {
            let amount = this.props.invoice.total || 0;
            if (this.props.invoice.payments) {
                for (let p of this.props.invoice.payments.filter(p => p.status !== 'refunded')) {
                    amount -= p.amount;
                }
            }
            payment.amount = parseFloat(amount.toFixed(2));
            const isPaid = payment.amount <= 0;
            this.setState({
                resource: this.props.invoice,
                reload: false,
                payment,
                isPaid
            })
        }
    }

    handlePaymentUpdate = (updatedPayment) => {
        const payments = this.state.resource.payments.map(p =>
            p.id === updatedPayment.id ? updatedPayment : p
        );
        const paymentsTotal = payments.filter(p => p.status !== 'refunded').reduce((sum, p) => sum + parseFloat(p.amount), 0)
        const totalAmount = this.props.invoice.total - paymentsTotal;

        this.setState({
            resource: {
                ...this.state.resource,
                payments
            },
            payment: {
                ...this.state.payment,
                amount: totalAmount.toFixed(2)
            }
        });
    };

    render() {
        const term_types = mapForSelect(this.props.term_types);
        const {
            resource,
            isEdited,
            isPaid,
            isDateValidated,
            isPaymentValidated,
            isTermValidated,
            payment,
            addingPayments
        } = this.state;
        const {invoice, manualPaymentTypes, isMobile} = this.props;

        let totalPaidAmount = 0;
        if (invoice && invoice.payments && invoice.payments.length > 0) {
            invoice.payments.filter(p => p.status !== 'refunded').forEach(payment => {
                totalPaidAmount += +payment.amount
            })
            if (parseFloat(invoice.total) === parseFloat(totalPaidAmount)) {
                payment.amount = 0
            }
        }

        return (
            <Modal
                {...this.props}
                id="term_modal"
                bsSize="big"
                animation={true}
                onHide={() => {
                    this.resetAmountsToOriginal()
                    this.resetValues()
                    this.setState({ reload: true })
                    this.props.onHide()
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{invoice ? `Invoice #${invoice.no}` : `New Invoice`}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="top15">
                    <Row>
                        <Col md={6} className={isMobile ? 'bottom15' : null}>
                            <div><strong className="small-margin">Term</strong></div>
                            <Select className="Select" classNamePrefix="select"
                                    placeholder="Term"
                                    value={select(term_types, resource.term_type_id)}
                                    onChange={e => {
                                        this.selectResourceAttr('term_type_id')(e);
                                        const term = this.props.term_types.find(term => term.id === e.value);
                                        const days = term.term;
                                        const invoiced = moment(resource.invoiced_at);
                                        if (term.name === 'Last Day Of Month') {
                                            resource.due_date = invoiced.endOf('month')
                                        } else {
                                            resource.due_date = moment(invoiced, "DD-MM-YYYY").add(days, 'days');
                                        }
                                        this.setState(resource);
                                    }}
                                    options={term_types}
                            />
                        </Col>
                        <Col md={6}>
                            <div><strong className="small-margin">Invoice Date</strong></div>
                            <Datetime
                                className='modal-datetime'
                                dateFormat={defaultDateFormat}
                                isClearable
                                timeFormat={defaultTimeFormat}
                                value={moment(resource.invoiced_at)}
                                inputProps={{placeholder: 'Invoice Date'}}
                                onChange={this.dateResourceAttr('invoiced_at')}
                            />
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col md={6} className={isMobile ? 'bottom15' : null}>
                            <div><strong className="small-margin">Due Date</strong></div>
                            <Datetime
                                className='modal-datetime'
                                dateFormat={defaultDateFormat}
                                isClearable
                                timeFormat={defaultTimeFormat}
                                value={moment(resource.due_date)}
                                inputProps={{placeholder: 'Due Date'}}
                                onChange={this.dateResourceAttr('due_date')}
                            />
                        </Col>
                        <Col md={6}>
                            <div><strong className="small-margin">Final Paid Date</strong></div>
                            <Datetime
                                className={isTermValidated ? 'modal-datetime' : 'validation-error modal-datetime'}
                                dateFormat={defaultDateFormat}
                                isClearable
                                timeFormat={defaultTimeFormat}
                                value={resource.paid_at ? moment(resource.paid_at) : null}
                                inputProps={{placeholder: 'Paid date', disabled: this.state.isPaid}}
                                onChange={e => {
                                    let newValue = null
                                    if (moment(e).isValid() && moment(e).format(defaultDateTimeFormat) !== "Invalid date") {
                                        newValue = e
                                    }
                                    this.dateResourceAttr('paid_at', () => {
                                        let {resource} = this.state;
                                        resource.proposal_service_id = invoice && invoice.proposal_service_id;
                                        this.setState(resource)
                                    })(newValue)
                                }}
                            />
                        </Col>
                    </Row>
                    <br/>
                    {!isPaid && <><Row>
                        <Col md={3} className={isMobile ? 'bottom15' : null}>
                            <div><strong className="small-margin">Amount</strong></div>
                            <InputGroup>
                                <InputGroupAddon>
                                    $
                                </InputGroupAddon>
                                {isEdited && this.state.partial && !resource.paid_at ?
                                    <FormControl
                                        type="text"
                                        className={isPaymentValidated ? null : 'validation-error'}
                                        onChange={(e) => {
                                            let {resource, payment} = this.state;
                                            const newAmount = (e && e !== '' && e.target.value !== '') ? e.target.value : 0;
                                            payment = {...payment, amount: newAmount};
                                            resource.proposal_service_id = invoice && invoice.proposal_service_id;
                                            this.setState({payment})
                                        }}
                                        onBlur={() => {
                                            const {payment} = this.state;
                                            this.setState({
                                                isEdited: false,
                                                isPaymentValidated: payment.amount > 0 || (+invoice.total === 0 && payment.amount >= 0)
                                            });
                                        }}
                                        value={payment.amount}
                                    />
                                    :
                                    <FormControl
                                        className={isPaymentValidated ? null : 'validation-error'}
                                        type="text"
                                        onFocus={() => this.setState({isEdited: true})}
                                        onBlur={() => {
                                            const {payment} = this.state;
                                            this.setState({isPaymentValidated: payment.amount > 0 || (+invoice.total === 0 && payment.amount >= 0)});
                                        }}
                                        value={this.parseDecimal(payment.amount)}
                                    />}
                            </InputGroup>

                        </Col>

                        {!resource.paid_at &&
                            <Col md={3} className={isMobile ? 'bottom15' : 'term-modal-input'}>
                                <ColorCheckbox value={this.state.partial}
                                               label='Partial payment'
                                               onChange={e => {
                                                   let {payment} = this.state;
                                                   let {invoice} = this.props;
                                                   payment.payment_date = moment();

                                                   let amount = invoice.total
                                                   if (invoice.payments) {
                                                       for (let p of invoice.payments.filter(p => p.status !== 'refunded')) {
                                                           amount -= p.amount
                                                       }
                                                   }
                                                   payment.amount = parseFloat(amount.toFixed(2))

                                                   this.setState({
                                                       payment: {...payment, payment_type_id: e.value},
                                                       isPaymentValidated: payment.amount > 0 || (+invoice.total === 0 && payment.amount >= 0),
                                                       partial: !this.state.partial
                                                   })
                                               }}
                                />
                            </Col>}

                        {this.state.partial && !resource.paid_at &&
                            <Col md={4} className={isMobile ? 'bottom15' : null}>
                                <div><strong className="small-margin">Partial payment date</strong></div>
                                <Datetime
                                    className={isDateValidated ? 'modal-datetime' : 'validation-error modal-datetime'}
                                    dateFormat={defaultDateFormat}
                                    isClearable
                                    timeFormat={defaultTimeFormat}
                                    value={moment(payment.payment_date)}
                                    inputProps={{placeholder: 'Payment date'}}
                                    onChange={e => {
                                        let {resource, payment} = this.state;
                                        payment = {...payment, payment_date: (e && e !== '') ? e : null};
                                        resource.proposal_service_id = invoice && invoice.proposal_service_id;
                                        this.setState({payment})
                                    }}
                                />
                            </Col>}

                        <Col md={2} className={isMobile ? 'bottom15' : 'term-modal-input'}>
                            <Button
                                disabled={(invoice && invoice.total === 0) || this.props.loading}
                                onClick={() => {
                                    const remaining = parseFloat(invoice.total) - (invoice.payments?.reduce((sum, p) => p.status === "refunded" ? sum : sum + (+p['amount'] || 0), 0) || 0);
                                    if ((+invoice.total !== 0 && +payment.amount <= 0) || +payment.amount > remaining || (+invoice.total === 0 && +payment.amount < 0)) {
                                        this.setState({isPaymentValidated: false})
                                    } else if (this.state.partial && !payment.payment_date) {
                                        this.setState({isDateValidated: false})
                                    } else {
                                        this.setState({addingPayments: true}, () => {
                                            this.props.onPaymentAdd(invoice.token, payment.amount, resource.paid_at ? resource.paid_at : payment.payment_date, payment.payment_type_id, payment.reference_no, () => {
                                                this.props.onHide()
                                                this.setState({addingPayments: false})
                                            })
                                            this.resetValues()
                                        })
                                    }
                                }}>
                                Add
                            </Button>
                        </Col>
                    </Row>
                        <Row>
                            {!resource.paid_at &&
                                <Col md={3} className={isMobile ? 'bottom15' : 'term-modal-input'}>
                                    <div><strong className='small-margin'>Reference no</strong></div>
                                    <FormControl placeholder="Reference no."
                                                 value={payment.reference_no}
                                                 onChange={(e) => this.setState({
                                                     payment: {
                                                         ...payment,
                                                         reference_no: e.target.value
                                                     }
                                                 })}>
                                    </FormControl>
                                </Col>
                            }
                        </Row></>}
                </Modal.Body>
                {invoice && invoice.payments && invoice.payments.length > 0 &&
                    <Payments
                        show={this.state.resource}
                        onPaymentUpdate={this.handlePaymentUpdate}
                        onRefund={this.props.onPaymentRefund}
                        onUpdate={this.props.onPaymentUpdate}
                        onDelete={this.props.onPaymentDelete}/>}
                <Modal.Footer>
                    <Row style={{display: isMobile ? 'flex' : null}}>
                        <Col md={6} xs={6} className="text-left">
                            <Button bsSize="small" onClick={() => {
                                this.resetAmountsToOriginal()
                                this.resetValues()
                                this.props.onHide()
                            }}>Close</Button>
                        </Col>
                        <Col md={6} xs={6} className="text-right">
                            <Button
                                bsStyle="success"
                                bsSize="small"
                                disabled={addingPayments || !this.props.show}
                                onClick={() => {
                                    if (!resource.paid_at && ((+invoice.total !== 0 && payment.amount < 0) || (+invoice.total === 0 && payment.amount < 0))) {
                                        this.setState({isPaymentValidated: false})
                                    } else if ((resource.paid_at && payment.amount > 0) || (!resource.paid_at && ((+invoice.total === 0 && payment.amount < 0) || (+invoice.total !== 0 && payment.amount < 0)))) {
                                        this.setState({isTermValidated: false})
                                    } else {
                                        this.props.onSave(resource, invoice)
                                        this.resetValues()
                                    }
                                }}
                            >Save
                            </Button>
                        </Col>
                    </Row>

                </Modal.Footer>
            </Modal>
        )
    }
}

const TermModalWithMedia = withMediaQuery(TermModal, {
    isMobile: {maxWidth: 991},
});

export default TermModalWithMedia;
